import React, {Component} from 'react';
import server from '../../server';

class LatestAppointment extends Component{

    state={
        fisioterapistData:{}
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.latestAppointment)
            server.get("users/" + nextProps.latestAppointment.fisioterapistId,(data) => {
                this.setState({fisioterapistData: data})
            });
    }

   render(){
        return(
            <div class="form-group col-md-6 m-0 p-0">
                <div class="col-md-12 mT-20">
                    <div class="mL-20">
                        <h3 class=" m-0 p-0">Último atendimento</h3>
                        <p class="c-client-secondary fsz-sm">{this.props.latestAppointment.date}</p>
                    </div>
                    {this.props.latestAppointment.status != 0 ?
                    <div>
                        <div class="pB-0 peers ai-c bdB mB-10 mL-20 pB-20">
                            <img class="w-10r bdrs-50p user-image bdc-client-default" src="https://randomuser.me/api/portraits/men/10.jpg"
                                alt=""/>
                            <div class="mL-20">
                                <h5 class="c-client-default">
                                    <div class="fsz-md mB-10">
                                        <b>{this.state.fisioterapistData.name}</b>
                                    </div>

                                    <div class="fsz-xs c-client-secondary">Especialidade</div>
                                    <span class="fsz-sm">Articulações e coluna</span>
                                    <div class="clearfix"></div>
                                    <div class="fa fa-star mR-5 star active-full"></div>
                                    <div class="fa fa-star mR-5 star active-full"></div>
                                    <div class="fa fa-star mR-5 star active-full"></div>
                                    <div class="fa fa-star mR-5 star"></div>
                                    <div class="fa fa-star mR-5 star"></div>
                                </h5>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="w-100p pX-10 pY-5 ai-c">
                                <div class="fsz-xs c-client-default">Fotos e vídeos</div>
                                <div class="client-midias mT-5">
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                    <img class="bdrs-2  w-100p" src="https://randomuser.me/api/portraits/men/10.jpg"
                                        alt="" />
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="col-sm-12 mT-20">
                            <div class="fsz-xs c-client-default">Comentário fisioterapeuta</div>
                            <p>{this.props.latestAppointment.commentary_patient}</p>
                        </div>
                        {/**<div class="col-sm-12">
                            <div class="form-group col-xs-12 mT-20">
                                <label for="inputCep">Responder comentário</label>
                                <textarea class="form-control" rows="4" name="toDoctor" placeholder="Algum comentário para o fisioterapeuta?" />
                                <span class="fsz-sm c-client-secondary">*Você pode editar esse comentário.</span>
                                </div>
                            <div class="form-group ta-c col-xs-12">
                                <button class="btn btn-client-default" type="button">Responder</button>
                            </div>
                    </div>**/}
                    </div> : <div class="pB-0 peers ai-c bdB mB-10 mL-20 pB-20"></div>}
                </div>
            </div>
        )
    }
}

export default LatestAppointment;


// WEBPACK FOOTER //
// ./src/pages/evolution/LatestAppointment.js